import { render, staticRenderFns } from "./time-table-expand.vue?vue&type=template&id=23b4758d"
import script from "./time-table-expand.vue?vue&type=script&lang=js"
export * from "./time-table-expand.vue?vue&type=script&lang=js"
import style0 from "./time-table-expand.vue?vue&type=style&index=0&id=23b4758d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports